/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1LocationCities202,
  PostApiV1LocationCities400,
  PostApiV1LocationCities401,
  PostApiV1LocationCities404,
  PostApiV1LocationCities409,
  PostApiV1LocationCities500,
  PostApiV1LocationCitiesMutationRequest,
  PostApiV1LocationCitiesMutationResponse,
} from "../../types/locationCityController/PostApiV1LocationCities.ts";
import { cityViewModelSchema } from "../cityViewModelSchema.ts";
import { createCityRequestViewModelSchema } from "../createCityRequestViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1LocationCities202Schema = z.lazy(
  () => cityViewModelSchema,
) as unknown as ToZod<PostApiV1LocationCities202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1LocationCities400Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCities400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1LocationCities401Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCities401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1LocationCities404Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCities404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1LocationCities409Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCities409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1LocationCities500Schema =
  z.any() as unknown as ToZod<PostApiV1LocationCities500>;

export const postApiV1LocationCitiesMutationRequestSchema = z.lazy(
  () => createCityRequestViewModelSchema,
) as unknown as ToZod<PostApiV1LocationCitiesMutationRequest>;

export const postApiV1LocationCitiesMutationResponseSchema = z.lazy(
  () => postApiV1LocationCities202Schema,
) as unknown as ToZod<PostApiV1LocationCitiesMutationResponse>;
